import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { AsideMenuItem } from './AsideMenuItem'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { permissionCheck } from '../../../../app/helper-functions/PermissionCheck';
import { DrawerComponent, MenuComponent, ScrollComponent, ToggleComponent } from '../../../assets/ts/components';
import { useNavigate } from 'react-router-dom';
let user_add, user_view, user_logs;
let role_add,role_log,role_view;
function UserManagementAside() {
  const navigate=useNavigate();
  useEffect(() => {
    navigate("/hr/user-managements/users/add-user")
  }, [])
  const intl = useIntl()
  user_add = permissionCheck('user-create')
  user_view = permissionCheck('user-view')
  user_logs = permissionCheck('user-activity-log')
  role_add = permissionCheck('role-create')
  role_view = permissionCheck('role-view')
  role_log = permissionCheck('role-activity-log')
  return (
   <>
       {/* Settings */}
       <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>User Managment</span>
        </div>
      </div>
      {user_add || user_logs || user_view ?(
      <AsideMenuItemWithSub
        to='/hr/user-managements'
        title='Users'
        fontIcon='bi-archive'
        icon='fa fa-user-plus'
      >
        {user_add&&(<AsideMenuItem to='/hr/user-managements/users/add-user' title='Add User' hasBullet={true} />)}
        {user_view&&(<AsideMenuItem to='/hr/user-managements/users/users-list' title='List of Users' hasBullet={true} />)}
        {user_logs&&(<AsideMenuItem to='/hr/user-managements/users/all-user-logs' title='All logs of Users' hasBullet={true} />)}
      </AsideMenuItemWithSub>
):null}
       {
        role_add || role_log || role_view ? (
          <AsideMenuItemWithSub
          to='/hr/user-managements'
          title='Roles'
          fontIcon='bi-archive'
          icon='fas fa-user-shield'
        >
          {
            role_add && (
              <AsideMenuItem to='/hr/user-managements/roles/add-role' title='Add Role' hasBullet={true} />
            )
          }
          {
            role_view && (
              <AsideMenuItem to='/hr/user-managements/roles/roles-list' title='List of Roles' hasBullet={true} />
            )
          }
          {
            role_log && (
              <AsideMenuItem to='/hr/user-managements/roles/all-roles-logs' title='All Roles Logs' hasBullet={true} />
            )
          }
        </AsideMenuItemWithSub>
        ):null
      }
   </>
  )
}

export default UserManagementAside;